import React from 'react';
const loadingSrc = require('../images/loading.svg');

export default class LoadingIndicator extends React.Component {
    constructor() {
        super();
        this.state = {
        };
    }

    render() {
        if (!this.props.loading)
            return null;
        else {
            return (
                <div className="loading-indicator">
                    <img src={loadingSrc} height="60" />
                    {this.props.text && this.props.text !== '' &&
                        <div className="container infotext">
                            <span style={{whiteSpace: "pre-line"}}>{this.props.text}</span>
                        </div>
                    }
                </div>
            );
        }
    }
}